export default __webpack_public_path__ + "static/media/error404.e6c602e2.png";